import { Route, Switch } from 'react-router-dom';
import FreeTrial from '../../components/free-trial';
import ThankYou from '../../components/free-trial/thank-you';
import PageNotFound from '../../components/page-not-found';

const FreeTrialContainer = () => (
  <Switch>
    <Route exact path='/free-trial/buy' component={FreeTrial} />
    <Route exact path='/free-trial/thank-you' component={ThankYou} />
    <Route component={PageNotFound} />
  </Switch>
);

export default FreeTrialContainer;
